import { CtaButton, CtaButton2 } from "@/app/lib/Button";
import Image from "next/image";

export default function Slide1() {
  return (
    <div className="w-full h-[862px] lg:h-[504px] flex items-center justify-center bg-gradient-to-b from-[#9CC4F6] to-[#ffffff] px-[16px] lg:px-[56px] py-[24px] lg:py-[48px]">
      <div className="max-w-7xl w-full flex flex-col-reverse lg:flex-row items-center justify-between gap-[32px] lg:gap-[40px]">
        <div className="flex-1 flex justify-center min-w-0">
          <Image
            src="/tutor_image.webp"
            alt="Instructor"
            width={360}
            height={360}
            priority
            className="object-contain h-[325px] w-auto lg:h-[360px]"
          />
        </div>
        <div className="w-auto lg:max-w-[560px] flex flex-col items-center lg:items-start gap-[24px] lg:gap-[32px]">
          <div className="flex flex-col items-center lg:items-start gap-[16px]">
            <div className="bg-white px-[20px] py-[12px] rounded-[12px]">
              <h2 className="text-[#1A1A1A] text-[48px] md:text-[61px] text-center lg:text-left leading-[100%] font-[600]">
                <span className="text-primary">Unlock </span>Your Financial
                Potential
              </h2>
            </div>
            <div>
              <h3 className="text-[32px] md:text-[36px] text-center lg:text-left text-[#484848] leading-[100%] font-[600]">
                with Expert-led <br />
                Finance Certification Courses
              </h3>
            </div>
          </div>
          <div className="flex flex-col md:flex-row gap-[12px] w-full md:w-auto items-center">
            <div className="w-full md:w-auto">
              <CtaButton text={"Start Learning Now"} />
            </div>
            <div className="w-full md:w-auto">
              <CtaButton2 text={"UPCOMING BATCHES"} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
